// src/App.js
import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import routes from "./routes";
import Spinner from "./CommonComponents/Spinner";
import "primereact/resources/themes/lara-light-indigo/theme.css"; // or any other theme
import "primereact/resources/primereact.min.css"; // core css
import "./App.css";
import "./custom-style.css";
import "./custom-admin-style.css";

function App() {
  return (
    <Suspense fallback={<Spinner isLoading={true} />}>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    </Suspense>
  );
}

export default App;
